import { Link } from "react-router-dom";

interface CategoryCard {
  name: string;
  url: string;
  image: string;
}

const categoryCards: CategoryCard[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20warm%20sand%20colored%20leather%20sneakers%20on%20smooth%20cream%20surface%20soft%20natural%20daylight%20minimal%20shoe%20product%20photography%20clean%20composition%20with%20gentle%20shadows%20showing%20textured%20sole%20and%20clean%20upper%20design&width=600&height=450&seq=grid-shoes-v2&orientation=landscape",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Dusty%20rose%20oversized%20hoodie%20draped%20gracefully%20on%20warm%20beige%20linen%20surface%20soft%20diffused%20morning%20light%20minimal%20clothing%20flatlay%20photography%20clean%20feminine%20aesthetic%20with%20subtle%20fabric%20texture%20details&width=600&height=450&seq=grid-hoodies-v2&orientation=landscape",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20quality%20terracotta%20colored%20cotton%20tshirt%20neatly%20folded%20on%20cream%20paper%20surface%20with%20natural%20window%20light%20minimal%20apparel%20product%20photography%20clean%20simple%20composition%20showing%20smooth%20fabric&width=600&height=450&seq=grid-tshirts-v2&orientation=landscape",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Classic%20tan%20suede%20bomber%20jacket%20hanging%20on%20minimal%20dark%20wooden%20hanger%20against%20warm%20cream%20wall%20soft%20directional%20lighting%20editorial%20fashion%20product%20photography%20elegant%20composition%20showing%20rich%20suede%20texture&width=600&height=450&seq=grid-jackets-v2&orientation=landscape",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Light%20sage%20green%20linen%20trousers%20folded%20with%20care%20on%20warm%20wooden%20surface%20soft%20natural%20light%20minimal%20clothing%20product%20photography%20clean%20relaxed%20aesthetic%20showing%20natural%20fabric%20drape%20and%20texture&width=600&height=450&seq=grid-pants-v2&orientation=landscape",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Warm%20camel%20toned%20unstructured%20dad%20cap%20resting%20on%20smooth%20cream%20surface%20soft%20diffused%20overhead%20lighting%20minimal%20headwear%20product%20photography%20clean%20simple%20composition%20showing%20curved%20brim%20shape%20and%20subtle%20fabric&width=600&height=450&seq=grid-headwear-v2&orientation=landscape",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Matching%20set%20of%20dusty%20blue%20hoodie%20and%20relaxed%20jogger%20pants%20folded%20together%20on%20cream%20linen%20fabric%20soft%20natural%20lighting%20minimal%20loungewear%20product%20photography%20editorial%20style%20showing%20coordinated%20set%20harmony&width=600&height=450&seq=grid-sets-v2&orientation=landscape",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20premium%20cotton%20underwear%20bundle%20in%20warm%20charcoal%20gray%20tone%20arranged%20on%20cream%20paper%20surface%20soft%20diffused%20studio%20lighting%20minimal%20intimate%20apparel%20photography%20clean%20simple%20composition%20showing%20gentle%20texture&width=600&height=450&seq=grid-underwear-v2&orientation=landscape",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Performance%20athletic%20jersey%20in%20deep%20navy%20blue%20with%20subtle%20texture%20folded%20on%20light%20gray%20surface%20natural%20window%20light%20minimal%20sportswear%20product%20photography%20showing%20breathable%20fabric%20pattern%20and%20clean%20modern%20cut&width=600&height=450&seq=grid-jersey-v2&orientation=landscape",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Artful%20arrangement%20of%20minimalist%20gold%20toned%20jewelry%20pieces%20and%20slim%20woven%20scarf%20on%20cream%20linen%20surface%20soft%20natural%20lighting%20editorial%20accessories%20photography%20elegant%20composition%20with%20gentle%20shadows%20and%20varied%20textures&width=600&height=450&seq=grid-accessories-v2&orientation=landscape",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Structured%20olive%20green%20canvas%20backpack%20with%20leather%20trim%20placed%20on%20light%20wooden%20surface%20soft%20natural%20lighting%20minimal%20bag%20product%20photography%20clean%20composition%20showing%20functional%20design%20and%20premium%20materials&width=600&height=450&seq=grid-bags-v2&orientation=landscape",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Rich%20burgundy%20genuine%20leather%20belt%20artfully%20coiled%20on%20warm%20cream%20paper%20surface%20soft%20diffused%20side%20lighting%20minimal%20fashion%20accessory%20photography%20showing%20detailed%20edge%20stitching%20and%20brushed%20gunmetal%20buckle&width=600&height=450&seq=grid-belts-v2&orientation=landscape",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20saffron%20colored%20liquid%20on%20cream%20background%20with%20soft%20golden%20hour%20light%20luxury%20fragrance%20product%20photography%20clean%20refined%20composition%20showing%20gentle%20reflections%20and%20subtle%20label%20detail&width=600&height=450&seq=grid-perfumes-v2&orientation=landscape",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Curated%20assortment%20of%20lifestyle%20items%20including%20handmade%20ceramic%20mug%20soy%20candle%20and%20linen%20notebook%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20still%20life%20photography%20clean%20minimal%20aesthetic%20with%20earthy%20tones&width=600&height=450&seq=grid-other-v2&orientation=landscape",
  },
];

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-16">
          <p className="text-xs tracking-[0.25em] uppercase text-foreground-500 mb-3 font-label">Browse by</p>
          <h2 className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">Category</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categoryCards.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl border border-background-200/70 overflow-hidden bg-background-50 hover:border-foreground-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] bg-background-100 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
              </div>
              <div className="p-5 md:p-6 flex items-center justify-between">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900">{cat.name}</h3>
                <span className="flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Open <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/itaobuy-sheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Learn How to Source Smarter — Read the Guide
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}